var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertSuccess = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    className: "injected-svg",
    "data-src": "assets/ws10/icons/SourceStateIcons/success-inverse.svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 192,
    height: 192,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 16a80 80 0 1 0 80 80 80 80 0 0 0-80-80Zm53.25 47.11-72.63 72.64-33.84-33.87a4 4 0 0 1 5.65-5.66l28.19 28.18 66.95-66.95a4 4 0 1 1 5.68 5.66Z",
    fill: "#FFFFFF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alert_success.e013ac443d3cf27b96b3c975c16aa69c.svg";